import React from 'react'
import Button from '../Button'
import './Complaint.sass'
import Col from "../Col"
import Container from "../Container"
import Icon from '../Icon'

const Complaint = (handleClickOverflow) => (
  <section className="complaint-wrapper">
    <Container>
      <Col xs={6} sm={8} md={18} lg={18}>
        <div className="complaint">
          <h4 className="complaint__caption">Возникли проблемы с получением услуги?</h4>
          <p className="complaint__text">
            Отказали в приёме документов или предоставлении услуги,
            нарушили сроки, требуют дополнительные документы или оплату?
            На нашем портале вы можете пожаловаться на некачественное предоставление услуги.
          </p>
        </div>
      </Col>
      <Col xs={6} sm={3} md={6} lg={6}>
        {/* eslint-disable */}
        <Button bsSize="large" bsStyle="primary" className="button-icon" onClick={handleClickOverflow}>Подать жалобу <Icon type='complaint' /></Button>
        {/* eslint-disable */}
      </Col>
    </Container>
  </section>
)

export default Complaint



// WEBPACK FOOTER //
// ./components/Service_Complaint/index.jsx